import { getAuth } from "firebase/auth";

const API_BASE = "https://us-central1-atomic-musicapp.cloudfunctions.net";

const verifyUserAuth = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not signed in");
    }

    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE}/verifyUserAuth`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`Backend error: ${response.status} - ${errorBody}`);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("verifyUserAuth error:", error);
    return { success: false, error: error.message };
  }
};

export default verifyUserAuth;
